import React, { useContext, useState } from 'react';

import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

import { DbxContext } from '../../../services/DbxContext';

const ToggleArchiveView = () => {
    const cache = useContext(DbxContext);
    const [showArchive, setShowArchive] = useState(Boolean(cache.read('show_archived')));

    const handleChange = checked => {
        (async () => {
            setShowArchive(Boolean(checked));
            
            cache.publish({
                topic: 'show_archived',
                value: Boolean(checked)
            });
        })()
        .then(() => window.location.reload())
    }

    return (
        <Tooltip title={`${showArchive ? 'Hide' : 'Show'} archived items`}>
            <Switch color="default" onChange={({ target: { checked }}) => handleChange(checked)} checked={showArchive} />
        </Tooltip>
    );
};

export default ToggleArchiveView;